import React from "react";

function QteBandes({ qteBandes, setQteBandes }) {
    const handleChange = (e) => {
        e.preventDefault();
        setQteBandes(e.target.value);
    };
    return (
        <div className="row">
            <div className="col-4">
                <div className="input-group my-3">
                    <div className="input-group-prepend">
                        <span className="input-group-text">
                            Nombres de bandes
                        </span>
                    </div>
                    <input
                        type="number"
                        min="3"
                        max="10"
                        className="form-control text-center"
                        value={qteBandes}
                        onChange={handleChange}
                    />
                </div>
            </div>
        </div>
    );
}

export default QteBandes;
